import { createContext } from 'react';

const ToolbarContext = /*#__PURE__*/createContext({
  onActionAnyItem: () => {}
});

export { ToolbarContext };
